import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resendVerification } from '../../api/signupApi';
import { FaCow, FaEnvelope  } from "react-icons/fa6";
import './VerifyMail.css';

export default function VerifyMail() {
    const location = useLocation();
    const navigate = useNavigate();
    const email = location.state?.email;
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleResend = async () => {
        setLoading(true);
        setMessage('');
        setError('');

        try {
            const token = localStorage.getItem('token');
            await resendVerification(token);
            setMessage('Email de vérification renvoyé avec succès!');
        } catch (err) {
            setError('Erreur lors de l\'envoi. Veuillez réessayer.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="verification-page">
            <div className="verification-container">
                <div className="logo-section">
                    <FaCow className="logo-icon" />
                    <h1>Gestion des Animaux</h1>
                </div>

                <div className="verification-card">
                    <div className="email-icon-wrapper">
                        <FaEnvelope />
                    </div>

                    <h2>Vérifiez votre email</h2>
                    <p className="verification-text">
                        Nous avons envoyé un email de vérification à <strong>{email}</strong>
                    </p>
                    <p className="verification-subtext">
                        Cliquez sur le lien dans l'email pour activer votre compte.
                    </p>

                    {message && <div className="success-message">{message}</div>}
                    {error && <div className="error-message">{error}</div>}

                    <button 
                        className="resend-button"
                        onClick={handleResend}
                        disabled={loading}
                    >
                        {loading ? 'Envoi en cours...' : 'Renvoyer l\'email'}
                    </button>

                    <button 
                        className="back-button"
                        onClick={() => navigate('/')}
                    >
                        Retour à la connexion
                    </button>
                </div>
            </div>
        </div>
    );
}